const relacionamentos = {
  nacionais: [
    {
      titulo: 'Abrapp (Associação Brasileira das Entidades Fechadas de Previdência Complementar)',
      descricao: `
      Parceria que envolve uma estreita troca de informações e a construção de projetos conjuntos para aprimorar as regras de investimento das entidades fechadas de previdência complementar.
				\n<br />Também participamos do Conselho de Autorregulação da Abrapp, grupo responsável por analisar e julgar descumprimentos às normas da associação. A entidade indica participantes para nossos conselhos de autorregulação.
			`,
    },
    {
      titulo: 'Abrasca (Associação Brasileira das Companhias Abertas)',
      descricao: `
			Participação mútua nos conselhos de autorregulação de ambas as entidades.
			`,
    },
    {
      titulo: 'ABVCAP (Associação Brasileira de Private Equity e Venture Capital)',
      descricao: `
			O Código de FIP/FIEE (Fundos de Investimento em Participações/Fundos de Investimento em Empresas Emergentes) é a principal iniciativa conjunta entre as duas associações. O documento reúne as melhores práticas para as instituições desse mercado. A ANBIMA cuida da supervisão das empresas, enquanto a ABVCAP consolida a base de dados desses fundos.
			`,
    },
    {
      titulo: 'AEF (Associação de Educação Financeira do Brasil)',
      descricao: `
			<p class="gri_text">Atuação como um dos mantenedores da entidade, que cria ações para estimular a educação financeira nos brasileiros e, assim, contribuir para o desenvolvimento econômico e social do país. <span class="gri_label blue">GRI <b>203-2</b></span></p> 
			`,
    },
    {
      titulo:
        'Ancord (Associação Nacional das Corretoras e Distribuidoras de Títulos e Valores Mobiliários, Câmbio e Mercadorias)',
      descricao: `
      Manutenção de debates e constante troca de informações. A entidade indica participantes para nossos conselhos de autorregulação.
			`,
    },
    {
      titulo: 'Apimec (Associação dos Analistas e Profissionais de Investimento do Mercado de Capitais)',
      descricao: `
      Participação no Conselho de Supervisão de Analistas de Valores Mobiliários, organismo responsável por analisar e julgar os descumprimentos à autorregulação da entidade. A Apimec indica participantes para nossos conselhos de autorregulação.
			`,
    },
    {
      titulo: 'B3',
      descricao: `
			O relacionamento se dá pela atuação conjunta em grupos, pela troca de informações e pelo debate e envio de sugestões de melhorias na regulação. 
			\n<br />\n<br />
			Participação na Câmara Consultiva de Emissores e Estruturadores de Ofertas para debate sobre temas relacionados ao mercado de capitais. Da mesma forma, representantes da B3 fazem parte de fóruns da Associação para discussões sobre temas importantes para o mercado, seja de forma pontual ou permanente.
			\n<br />\n<br />
			Além disso, a cada dois anos são realizadas importantes iniciativas em conjunto: o Congresso Brasileiro de Mercado de Capitais e a Agenda ANBIMA B3 de Mercado de Capitais. O evento aborda os principais temas em alta no setor, com nomes do cenário nacional e internacional, e o estudo traz uma série de iniciativas para contribuir com o fortalecimento do mercado.
			\n<br />	\n<br />		
			Há, ainda, uma parceria para receber informações de negociação secundária de debêntures, que são disponibilizadas no Sistema REUNE da Associação. A entidade também indica participantes para nossos conselhos de autorregulação.
			\n<br />\n<br />
			<b>BSM:</b> Interação com a Supervisão de Mercados da B3 sobre temas que envolvem o monitoramento do mercado. Entre eles, estão a análise de estudos de caso sobre manipulação de mercado, alinhamento sobre a fiscalização das instituições financeiras, compliance e estudos para diminuir a sobreposição de tarefas entre a supervisão do regulador e a da autorregulação da ANBIMA.
			`,
    },
    {
      titulo: 'Banco Central',
      descricao: `
			A partir de convênio firmado há mais de 40 anos, oferecemos suporte na operacionalização do Selic (Sistema Especial de Liquidação e de Custódia).
			\n<br />\n<br />
			Há contato frequente para aprimoramento à regulação, inclusive em resposta a audiências públicas, debates sobre formas de fortalecer o SFN (Sistema Financeiro Nacional) e no Comitê Consultivo de Câmbio, grupo que discute questões conjunturais e estruturais desse mercado.
			\n<br />\n<br \>
      Envio de informações de preços/índices de títulos públicos e privados, além das curvas de juros (ETTJ) e de crédito.
      `,
    },
    {
      titulo: 'BNDES',
      descricao: `
      Manutenção de uma agenda conjunta para estimular a maior presença do mercado de capitais nos projetos de financiamento de longo prazo. Desde 2013, está em vigor um convênio que prevê a troca de informações e a ampliação de canais em prol do desenvolvimento do setor. A parceria também permite o acesso ao Sistema REUNE, plataforma online com negociação secundária de debêntures e acesso a informações de preços/índices de títulos públicos e privados, além das curvas de juros (ETTJ) e de crédito.
			`,
    },
    {
      titulo: 'CAF (Comitê de Aquisições e Fusões)',
      descricao: `
      Participação no Conselho de Administração e Supervisão da Associação dos Apoiadores do Comitê de Aquisições e Fusões, instituição sem fins lucrativos que presta apoio técnico e administrativo ao CAF.
			`,
    },
    {
      titulo: 'CIEE (Centro de Integração Empresa-Escola)',
      descricao: `
      Oferecimento do curso online Como Investir em Você, sobre finanças pessoas e investimentos, aos estudantes que fazem parte do CIEE.
			`,
    },
    {
      titulo: 'Codim (Comitê de Orientação para Divulgação de Informações ao Mercado)',
      descricao: `
      Presença nos encontros mensais do grupo, que era responsável pela elaboração de pronunciamentos de orientação ao mercado, criados para divulgar informações das companhias abertas. O Comitê foi descontinuado em outubro de 2020.
			`,
    },
    {
      titulo: 'CNF (Confederação Nacional das Instituições Financeiras)',
      descricao: `
      Junto com outras entidades, integramos a diretoria da confederação que tem por objetivo orientar, coordenar, defender e representar os interesses das instituições financeiras por meio de interações com os poderes Legislativo e Executivo. Oferecemos subsídios técnicos para que a CNF elabore, por exemplo, propostas de emendas e pareceres sobre matérias que envolvem o setor financeiro no Congresso Nacional.
			`,
    },
    {
      titulo: 'CNSeg (Confederação Nacional das Seguradoras)',
      descricao: `
      Presença nas reuniões da Comissão de Investimentos da confederação, grupo que discute aprimoramentos para as regras das seguradoras. A entidade indica participantes para nossos conselhos de autorregulação.
			`,
    },
    {
      titulo: 'CNJ (Conselho Nacional de Justiça)',
      descricao: `
      Participação no Comitê Gestor do Bacenjud, sistema online do BC utilizado por juízes para pedir informações sobre movimentações bancárias de clientes das instituições financeiras e determinar o bloqueio de contas.
			`,
    },
    {
      titulo: 'CVM',
      descricao: `
      O intenso contato com a autarquia se dá por meio de parcerias, atuação em grupos e sugestões de melhorias à regulação. São três os convênios firmados com a CVM para potencializar as atividades, eliminar sobreposições nos trabalhos e otimizar tempo e recursos:
				\n<br />\n<br />
				<b>- Aplicação de penalidades e celebração de termos de compromisso:</b> assinado em 2008, prevê o aproveitamento pela CVM dos termos de compromisso e penalidades aplicadas pela Associação e vice-versa. Isso significa que, caso uma das duas entidades esteja julgando um caso que foi avaliado anteriormente pela outra, ela pode, a pedido da instituição, considerar a penalidade aplicada na hora de finalizar o seu processo;
				\n<br />\n<br />
				<b>- Análise prévia de ofertas públicas:</b> também firmado em 2008. A Associação é responsável por verificar todos os documentos, incluindo materiais publicitários, antes que uma oferta via Instrução CVM 400 chegue ao mercado. Seis produtos fazem parte do acordo: ações, debêntures, cotas de fundos imobiliários e de FIPs, FIDCs e lastros de CRIs;
				\n<br />\n<br />
				<b>- Aproveitamento da supervisão de fundos:</b> assinado em 2018, o convênio prevê três linhas de atuação. A primeira estabelece que instituições e pessoas físicas podem solicitar a habilitação como administradoras de carteiras e valores mobiliários à CVM por meio do SSM, sistema online da Associação. Assim, a ANBIMA é responsável por avaliar os documentos e enviar um relatório para a CVM, que decide pela aprovação (ou não) do pedido. As empresas também podem aproveitar para pedir adesão aos códigos de autorregulação simultaneamente. Há outras duas linhas da parceira, que tratam da precificação de ativos e da distribuição de cotas de fundos.
				\n<br />\n<br />
				A Associação também participa de três grupos da autarquia, que são:
				\n<br />\n<br />
				<b>Comitê Consultivo de Educação:</b> fórum voltado ao apoio e à promoção de projetos de educação financeira para a população.
				\n<br />\n<br />
				<b>LAB (Laboratório de Inovação Financeira):</b> criada pela autarquia em parceria com a ABDE (Associação Brasileira de Desenvolvimento) e o BID (Banco Interamericano de Desenvolvimento) em 2017, a iniciativa reúne representantes do governo, do mercado e da sociedade, com o objetivo de estimular a criação de soluções inovadoras de financiamento para projetos, especialmente aqueles com viés social e/ou ambiental.
				\n<br />\n<br />
				<b>NEC (Núcleo de Estudos Comportamentais):</b> grupo composto por especialistas em ciências sociais e comportamentais convidados pela CVM. O objetivo é elaborar recomendações e subsídios técnicos para aprimorar as políticas de educação ao investidor, incluindo formas de disseminar informação e orientação para esse público.
			`,
    },
    {
      titulo: 'Febraban (Federação Brasileira de Bancos)',
      descricao: `
      Manutenção de uma agenda sobre temas de interesse comum. Participação na Comissão Intrassetorial sobre Sustentabilidade e Meio Ambiente, fórum criado para alinhar os mercados financeiro e de capitais brasileiros a temas socioambientais, e também no GT Blockchain, que trata das questões técnicas e dos possíveis usos dessa tecnologia. A entidade indica participantes para nossos conselhos de autorregulação.
				\n<br />\n<br />
				<b>Infi-Febraban:</b> apoio ao curso de capacitação de jovens negros para o mercado financeiro, criado pelo Instituto Febraban em parceria com a Faculdade Zumbi dos Palmares. Os alunos mais bem avaliados nas aulas ganham a inscrição para a prova da CPA-10 (Certificação Profissional ANBIMA – Série 10).
			`,
    },
    {
      titulo: 'FGV (Fundação Getulio Vargas)',
      descricao: `
      Patrocínio do NFC (Núcleo de Finanças Comportamentais) da FGV, que desenvolve estudos e eventos sobre finanças comportamentais, contribuindo para o fortalecimento do mercado financeiro.
			`,
    },
    {
      titulo: 'Fenaprevi (Federação Nacional de Previdência Privada)',
      descricao: `
      Parceira no desenvolvimento de propostas de aperfeiçoamento das regras de investimento das entidades abertas de previdência complementar. A entidade indica participantes para nossos conselhos de autorregulação.
			`,
    },
    {
      titulo: 'IBGC',
      descricao: `
      Participação no Grupo “Pratique e Explique” que tem como objetivo melhorar a transparência de governança das companhias abertas com foco no Código Brasileiro de Governança Corporativa.
			`,
    },
    {
      titulo: 'Insper',
      descricao: `
      Por meio da parceria com a instituição, a prova CPA-20 (Certificação Profissional ANBIMA – Série 20) é aplicada como parte da avaliação dos alunos em matéria optativa dos cursos de graduação de Administração e de Economia.
			`,
    },
    {
      titulo: 'Iepe/CdG (Instituto de Estudos de Política Econômica/Casa das Garças)',
      descricao: `
      O instituto é responsável por eleger a banca examinadora do Prêmio ANBIMA de Mercado de Capitais, que busca estimular o desenvolvimento de material acadêmico sobre o mercado. As melhores dissertações de mestrado e teses de doutorado nas áreas de Economia, Administração e Direito recebem bolsas de até R$ 34 mil para financiamento da pesquisa.
			`,
    },
    {
      titulo: 'Ministério da Economia',
      descricao: `
      Diferentes temas são trabalhados com as secretarias e grupos do Ministério:
				\n<br />\n<br />
				<b>IMK (Iniciativa Mercado de Capitais):</b> fórum que discute formas de fomentar o setor. Conta com diversos subgrupos que tratam de temas específicos, sempre com foco em aprimorar a regulação, estimular a poupança e o financiamento de longo prazo.
				\n<br />\n<br />
				<b>Receita Federal:</b> contato constante para tratar de melhorias na tributação.
				\n<br />\n<br />
				<b>SPE (Secretaria de Política Econômica):</b> condução dos aspectos técnicos referentes às pautas tocadas com o Ministério de forma geral.
				\n<br />\n<br />
				<b>SRPPS (Subsecretaria dos Regimes Próprios de Previdência Social):</b> debates sobre aprimoramentos nas regras de investimentos dos RPPSs.
				\n<br />\n<br />
				<b>Tesouro Nacional:</b> discussão de iniciativas e propostas de políticas econômicas sobre questões diversas que contribuam para o desenvolvimento do mercado de capitais. Também temos um acordo de cooperação técnica que regula o uso e a negociação das marcas dos índices de renda fixa pela ANBIMA para a utilização em ETFs.
			`,
    },
    {
      titulo: 'Ministério de Minas e Energia',
      descricao: `
      Relacionamento para estimular o projeto Renovabio (Política Nacional de Biocombustíveis), que busca incentivar investimentos sustentáveis como o ativo CBIO (Créditos de Descarbonização de Biocombustíveis).
			`,
    },
    {
      titulo: 'Ministério do Planejamento',
      descricao: `
      Discussão sobre incentivos à presença do mercado de capitais no financiamento de longo prazo.
			`,
    },
    {
      titulo: 'Planejar (Associação Brasileira de Planejadores Financeiros)',
      descricao: `
      Associados-sênior desde 2004, somos membros do conselho e da diretoria da entidade, que é responsável pela certificação CFP (Certified Financial Planner) no Brasil. A entidade indica participantes para nossos conselhos de autorregulação.
			`,
    },
    {
      titulo: 'PPI (Programa de Parcerias de Investimentos)',
      descricao: `
      Interação para elaborar propostas que impulsionem o financiamento à infraestrutura no país.
			`,
    },
    {
      titulo: 'Previc (Superintendência Nacional de Previdência Complementar)',
      descricao: `
      Manutenção de um convênio para cooperação com a superintendência e discussões sobre uma agenda comum, além da participação em eventos educacionais. Esse contato é a base para a manutenção de um diálogo frequente para esclarecimento de dúvidas e temas regulatórios. Além disto, a Previc reconhece a ANBIMA como a entidade responsável pela certificação dos dirigentes dos fundos de pensão: desde 2016 a superintendência considera a CPA-10, CPA-20 (Certificações Profissionais ANBIMA – séries 10 e 20, respectivamente), CEA (Certificação de Especialista em Investimentos ANBIMA) e CGA (Certificação de Gestores ANBIMA) obrigatórias para os profissionais de acordo com os diferentes cargos que eles podem ocupar.
			`,
    },
    {
      titulo: 'Susep (Superintendência de Seguros Privados)',
      descricao: `
      Convênio para troca de dados e informações, que busca fomentar o desenvolvimento dos mercados de capitais e de seguros; discussão permanente de aprimoramentos nas regras de investimentos das entidades abertas de previdência complementar e das seguradoras.
			`,
    },
  ],
  internacionais: [
    {
      titulo: 'Banco Mundial',
      descricao: `
      Contato para estimular a participação do mercado de capitais no financiamento de longo prazo no país.
			`,
    },
    {
      titulo: 'CFA Institute',
      descricao: `
			Em função da reformulação da CGA (Certificação de Gestores ANBIMA) e consequente criação da CGE (Certificação de Gestores ANBIMA para Fundos Estruturados) e da CFG (Certificação ANBIMA de Fundamentos de Gestão), o convênio com o CFA Institute foi revisto e renovado, garantindo que os detentores da CFA (Certified Financial Analyst) possam obter a equivalência com a CFG. Parceria com a CAIA Association também assegurou que os detentores da CAIA (Certified Alternatives Investments Analyst) possam requisitar a equivalência com a CFG.
			`,
    },
    {
      titulo: 'Fiafin (Federación Iberoamericana de Fondos de Inversión)',
      descricao: `
			Em 2020, ocupamos a vice-presidência da Federação Iberoamericana de Fundos de Investimento, que trata do desenvolvimento e de boas práticas para a indústria de fundos em cada um dos países que integram o grupo.
			`,
    },
    {
      titulo: 'ICMA (International Capital Market Association)',
      descricao: `
			Somos afiliados à Associação Internacional de Mercado de Capitais, com presença nas conferências realizadas anualmente e interações entre equipes. A interlocução contribui para trazer para o cenário brasileiro as principais discussões e novidades dos mercados internacionais, como o desenvolvimento de aspectos relacionados à sustentabilidade e à inovação.
			`,
    },
    {
      titulo: 'Ifie (International Forum for Investor Education)',
      descricao: `
			Atuação na diretoria do Fórum Internacional de Educação de Investidores para compartilhar experiências sobre o tema, e na coordenação do setor das Américas, organizando discussões com os demais países da região sobre melhores práticas na área.
			`,
    },
    {
      titulo: 'IIFA (The International Investment Funds Association)',
      descricao: `
      Assumimos, em 2020, a presidência da Associação Internacional de Fundos, que discute inovações recentes e promove ações em conjunto entre as diversas associações que representam a indústria de fundos ao redor do mundo. Participamos ativamente do comitê de segurança cibernética da Instituição, colaborando para iniciativas como Cyber Day.
			`,
    },
    {
      titulo: 'IIMV (Instituto Iberoamericano de Mercados de Valores)',
      descricao: `
      Participação em seminários promovidos pela entidade na América Latina.
			`,
    },
    {
      titulo: 'Iosco (International Organization of Securities Commissions)',
      descricao: `
			A Associação é membro da Organização Internacional das Comissões de Valores Mobiliários e contribui para diversas iniciativas na entidade. O principal grupo do qual participamos é o AMCC (Comitê Consultivo de Membros Afiliados), formado por autorreguladores, bolsas e infraestruturas de mercado, que dá suporte às pautas tratadas pela organização a partir da realização de estudos e levantamentos sobre temas específicos.
			\n<br />\n<br />
			Além disso, estamos presentes no Cosra (Conselho dos Reguladores de Valores Mobiliários das Américas), que discute questões regulatórias, e no Stakeholders Meeting, encontro da diretoria da Iosco com as entidades para debater a agenda anual de atividades.
			`,
    },
    {
      titulo: 'OCDE-Infe (International Network on Financial Education)',
      descricao: `
      Somos afiliados ao órgão, que elabora programas e iniciativas globais voltadas à educação financeira.
			`,
    },
    {
      titulo: 'SMPG (Securities Market Practice Group)',
      descricao: `
      Participação ativa no grupo da ISO (Organização Internacional de Normalização) voltado ao mercado financeiro, com acompanhamento mensal das discussões sobre a padronização da troca de mensagens e informações entre instituições financeiras.
			`,
    },
  ],
};

export { relacionamentos };
